import useSWR from 'swr';
import type { AxiosError } from 'axios';
import axios from 'axios';

const GetRuleEntityRelationship = (EntityAndPropertyName:string):{ isCollection: boolean | undefined,
  isLoading: boolean,
  isError: boolean, } => {
  const fetcher = (url: string) => axios.get<{ isCollection:boolean }>(url)
    .then((response) => response.data.isCollection);

  const { data, error } = useSWR<boolean, AxiosError>(
    EntityAndPropertyName
      ? `/policy/CheckForCollection?entityName_PropertyName=${EntityAndPropertyName}`
      : null,
    (url) => fetcher(url),
  );

  return {
    isCollection: data,
    isLoading: !error && !data,
    isError: Boolean(error),
  };
};

export default GetRuleEntityRelationship;
